/**
 * 値をカンマ区切りの文字列にして返す
 * @param value
 */
export const toLocaleString = (value) => {
    // 無効な値の場合
    if (value === null || value === undefined || value === '') {
        return '';
    }
    let num = value;
    // 文字列を数字変換
    if (typeof num === 'string') {
        num = Number(num);
    }
    // 無効な数字に変換できなければ原文を、有効な数字であればカンマ区切りにして返す
    return Number.isNaN(num) ? value.toString() : num.toLocaleString();
};
